import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/fuegodocs/theme/src/components/Layout/Layout.js";
export const AfChevronRightIcon = () => {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 17.085L15.5 12.005L10.5 6.91501" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>;
};
export const AfChevronLeftIcon = () => {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 6.91583L8.5 12L13.5 17.0842" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>;
};
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ResourcesList = makeShortcode("ResourcesList");
const ResourceLink = makeShortcode("ResourceLink");
const layoutProps = {
  AfChevronRightIcon,
  AfChevronLeftIcon,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Links render a semantic `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` tag and are primarily used for navigation. They inherit their parent's font-size but that value can be over-ridden using the `}<a parentName="p" {...{
        "href": "/react/getting-started/theming-api"
      }}><inlineCode parentName="a">{`sx prop`}</inlineCode></a>{`.`}</p>
    <h2>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {LinkWithIcon} from '@fuegokit/react'
`}</code></pre>


    <h2>{`Icon on the right (default)`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<LinkWithIcon subtle href={\`https://appfire.com/contact/\`} icon={<AfChevronRightIcon />}>
  Go to page
</LinkWithIcon>
`}</code></pre>
    <h2>{`Icon on the left`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<LinkWithIcon href={\`https://appfire.com/contact/\`} icon={<AfChevronRightIcon />} variant={\`iconBefore\`}>
  Go to page
</LinkWithIcon>
`}</code></pre>
    <h2>{`See also`}</h2>
    <ResourcesList mdxType="ResourcesList">
  <ResourceLink href={`/primitives/link`} mdxType="ResourceLink">Link</ResourceLink>
    </ResourcesList>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      